import { render, staticRenderFns } from "./romaplus.vue?vue&type=template&id=5071db42&scoped=true"
import script from "./romaplus.vue?vue&type=script&lang=js"
export * from "./romaplus.vue?vue&type=script&lang=js"
import style0 from "./romaplus.vue?vue&type=style&index=0&id=5071db42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5071db42",
  null
  
)

export default component.exports